import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { ColumnDefinition } from '../../../core/model/column-definition';
import { ExpandedListViewItemDefinition } from '../../../core/model/expanded-list-view-item';
import { CompanyService } from '../../../rent/service/data/company.service';
import { PropertyService } from '../../../rent/service/data/property.service';
import { LocalDate } from '../../../core/model/local-date';
import { canSubmitReportForm } from '../../utility/report-form-validation';

@Component({
    selector: 'app-property-view',
    templateUrl: './property-view.component.html',
    styleUrls: ['./property-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PropertyViewComponent implements OnInit {
  constructor(
    private _cdf: ColumnDefinitionFactory,
    private _companyService: CompanyService,
    private _dataService: PropertyService,
    fb: FormBuilder,
    fcf: FormControlExFactory
  ) {
    const today = new Date();
    this.from = LocalDate.fromDate(new Date(today.getFullYear(), 0, 1));
    this.to = LocalDate.fromDate(new Date(today.getFullYear(), 12, 0));

    this.form = fb.group({
      company: fcf.create('COMMON.COMPANY', ''),
      from: fb.group({}),
      to: fb.group({}),
    });
    this.columnDefinitions = [
      this._cdf.create('DASHBOARD.MENU.DWELLING', 'dwellingCount'),
      this._cdf.create('DASHBOARD.MENU.PARKING', 'parkingCount'),
      this._cdf.create('DASHBOARD.MENU.PREMISES', 'premisesCount'),
      this._cdf.create('DASHBOARD.MENU.OTHER_RENTAL_OBJECT', 'otherCount'),
      this._cdf.createMoney('LEASE_AGREEMENT_ROW.LIST_HEADER', 'rent'),
      this._cdf.createMoney('COMMON.RENT_LOSS', 'rentLoss'),
      this._cdf.create('COMMON.SQUARE_METER', 'surface'),
    ];
  }

  columnDefinitions: ColumnDefinition[] = [];
  companies: { name: string; value: string }[];
  dataContext: ExpandedListViewItemDefinition[] = [];
  form: FormGroup;
  from: LocalDate;
  to: LocalDate;
  protected expandAllRows: boolean = false;

  ngOnInit() {
    this._companyService.getList().subscribe(data => {
      this.companies = [{ name: 'ALL_TEXT', value: '' }];
      data.forEach(item => {
        this.companies.push({ name: item.toString(), value: item.id });
      });

      if (this.companies.length >= 2) {
        this.form.controls['company'].setValue(this.companies[1].value);
      }
    });
  }

  onPrintPages() {
    if (!canSubmitReportForm(this.form)) return;
    window.print();
  }

  onSubmit() {
    if (!canSubmitReportForm(this.form)) return;
    this.expandAllRows = false;

    this._dataService.getPropertyOverview(this.form.value).subscribe(data => {
      this.dataContext = data
        ? data.map(overview => {
            const model = new ExpandedListViewItemDefinition();
            model.caption = overview.propertyNumber + ' ' + overview.municipality + ' ' + overview.propertyName;
            model.columnDefinitions = [
              this._cdf.create('RENTAL_OBJECT_FORM.RENTAL_OBJECT_TYPE_LABEL', 'name'),
              this._cdf.create('COMMON.QUANTITY', 'numberOfRentalObjects'),
              this._cdf.createMoney('LEASE_AGREEMENT_ROW.LIST_HEADER', 'rent'),
              this._cdf.createMoney('COMMON.RENT_LOSS', 'rentLoss'),
              this._cdf.create('COMMON.SQUARE_METER', 'surface'),
            ];
            model.dataContext = overview;
            model.icon = 'account-statement';
            model.itemsSource = overview.rentalObjectTypes.map(x => {
              return {
                name: x.name,
                numberOfRentalObjects: x.numberOfRentalObjects,
                rent: x.rent,
                rentLoss: x.rentLoss,
                surface: x.surface,
              };
            });
            return model;
          })
        : [];
    });
  }

  toggleExpandAllRows() {
    this.expandAllRows = !this.expandAllRows;
  }
}
